import React from "react";

export default function ProgressBar({ history = [] }) {
  const has = (name) => history.some((h) => h.status === name);
  const findDate = (name) => history.find((h) => h.status === name)?.date || null;

  // Base dates
  const appliedDate = findDate("Applied");
  // const sentDate = findDate("Application Sent");

  // State checks
  const viewed = has("Application Viewed");
  const shortlisted = has("Shortlisted");
  const rejected = has("Rejected");
  const contacted = has("Contacted by Email");

  const steps = [
    { key: "Applied", label: "Applied", date: appliedDate },
    // { key: "Application Sent", label: "Application Sent", date: sentDate },
  ];

  // BEFORE recruiter sees application
  if (!viewed) {
    steps.push({
      key: "Awaiting Recruiter Action",
      label: "Awaiting Recruiter Action",
      date: findDate("Awaiting Recruiter Action"),
    });

    return render(steps);
  }

  // AFTER Application Viewed
  steps.push({
    key: "Application Viewed",
    label: "Application Viewed",
    date: findDate("Application Viewed"),
  });

  // EXACT RULE: Show ONLY ONE: Shortlisted OR Rejected
  if (shortlisted) {
    steps.push({
      key: "Shortlisted",
      label: "Shortlisted",
      date: findDate("Shortlisted"),
      type: "shortlist",
    });
  } else if (rejected) {
    steps.push({
      key: "Rejected",
      label: "Rejected",
      date: findDate("Rejected"),
      type: "reject",
    });
  }
   

  if (rejected) {
    return render(steps);
  }
  // Contacted by email (if present) — always before awaiting
  if (contacted) {
    steps.push({
      key: "Contacted by Email",
      label: "Contacted by Email",
      date: findDate("Contacted by Email"),
    });
  }

  // Finally: awaiting recruiter action
  const awaitingEntries = history.filter((h) => h.status === "Awaiting Recruiter Action");
  if (!rejected && awaitingEntries.length > 0) {
    const lastAwaitDate = awaitingEntries[awaitingEntries.length - 1].date;
    steps.push({
      key: "Awaiting Recruiter Action",
      label: "Awaiting Recruiter Action",
      date: lastAwaitDate,
    });
  }

  return render(steps);
}

function render(steps) {
  return (
    <div className="progress-row">
      {steps.map((s, i) => {
        const prev = i > 0 ? steps[i - 1] : null;
        const prevDone = prev ? !!prev.date : false;
        const done = !!s.date;

        return (
          <div className="progress-step" key={s.key}>
        
            {i !== 0 && <div className={`connector ${prevDone ? "active" : ""}`} />}

            {/* <div
              className={`circle ${
                s.type === "reject" ? "reject" : done ? "done" : ""
              }`}
            /> */}

            <div
            className={`circle ${
                s.type === "reject"
                ? "rejectt"
                : s.label === "Awaiting Recruiter Action"
                ? ""
                : done
                ? "done"
                : ""
            }`}
            />


            <div className="label">{s.label}</div>
            <div className="date">
              {s.date ? new Date(s.date).toLocaleDateString() : "—"}
            </div>
          </div>
        );
      })}
    </div>
  );
}
